import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const Interests = ({hibisId, scAnswer}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-interesi.jpg" xPos="28%" yPos="44%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Ali je zdaj pravi čas?</h1>
                    <p className="text-left">
                        Še vedno imate možnost izboljšati svojo finančno situacijo s pomočjo naše celovite ponudbe, <b>ampak razumemo, da morda zdaj ni pravi čas.</b>
                    </p>
                    <p className="text-left">
                        Vaš odgovor nam pomaga bolje razumeti, kako vam lahko ponudimo pravo rešitev.
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                    <Form guid="9a691cfa-31d6-45ca-8481-79eef9f4c5ce" hibisId={hibisId} scAnswer={scAnswer} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}